import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['name', 'results', 'registrationNumber', 'city', 'registrationDate']
  static values = { url: String }


  timeout = null
  lastQuery = null

  connect() {
    this.handleClickOutside = this.clickOutside.bind(this)
    document.addEventListener('click', this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside)
  }

  search() {
    const query = this.nameTarget.value.trim()

    if (query.length < 3) {
      this.clearResults()
      return
    }

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if (query === this.lastQuery) return
      this.lastQuery = query
      this.fetchAndRender(query)
    }, 400)
  }

  async fetchAndRender(query) {
    const response = await fetch(
      this.urlValue + `?name=${encodeURIComponent(query)}`
    )

    if (!response.ok) return

    const results = await response.json()
    this.renderResults(results)
  }

  renderResults(results) {
    if (results.length === 0) {
      this.clearResults()
      return
    }

    this.resultsTarget.innerHTML = results
      .map(result => `
        <li
          class='list-group-item list-group-item-action'
          data-action='click->legal-entity-lookup#select'
          data-siret='${result.siret}'
          data-name='${result.name}'
          data-city='${result.city}'
          data-registration-date='${result.registrationDate}'>
          <strong>${result.name}</strong><br>
          <small>${result.city}</small>
        </li>
      `)
      .join('')
  }

  select(event) {
    const item = event.currentTarget.dataset

    this.nameTarget.value = item.name

    if (this.hasRegistrationNumberTarget) {
      this.registrationNumberTarget.value = item.siret
    }

    if (this.hasCityTarget) {
      this.cityTarget.value = item.city
    }
    
    if (this.hasRegistrationDateTarget) {
      this.registrationDateTarget.value = item.registrationDate
    }

    this.clearResults()
  }

  clearResults() {
    this.resultsTarget.innerHTML = ''
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.clearResults()
    }
  }
}
